import React, { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Account } from "../types";
import MultimediaVideo from "../components/status/videos/MultimediaVideo";
import TeamsPerformanceSection from "../components/status/TeamsPerformanceSection";
import ProductionPerformancePart from "../components/status/ProductionPerformancePart";
import ProductionNotesPart from "../components/status/ProductionNotesPart";
import CalendarEventsPart from "../components/status/CalendarEventsPart";
import useInterval from "../hooks/useInterval";

export const titleStyle = { fontSize: "42px", fontWeight: "bold", lineHeight: "56px", color: "white", letterSpacing: "5px" };

interface VideoPartProps {
    onDone: () => void;
    tabs: Array<string>;
    showTeamPhotos?: boolean;
}

function VideoPart({ onDone, tabs, showTeamPhotos }: VideoPartProps) {
    return (
        <Row>
            <Col>
                <MultimediaVideo onDone={onDone} showTeamPhotos={showTeamPhotos} />
            </Col>
            <Col xs={"auto"}>
                <TeamsPerformanceSection tabs={tabs} showPhotos={showTeamPhotos} />
            </Col>
        </Row>
    );
}

export const STAY_DURATION = 15000;
export const VIDEO_INTERVAL = 15 * 60 * 1000; // 15 * 60 * 1000; // 15 minutes


interface StatusPageProps {
    tabs: Array<string>;
    activeTab: number;
    showTeamPhotos?: boolean;
}

export default function StatusPage({ tabs, showTeamPhotos = false }: StatusPageProps) {
    const [activePart, setActivePart] = useState(0);

    const showVideoPart = useRef(false);
    useInterval(() => {
        showVideoPart.current = true;
    }, VIDEO_INTERVAL);

    function showNextPart() {
        let next = activePart + 1;
        if (next > 2) {
            if (showVideoPart.current) {
                next = 3;
                showVideoPart.current = false;
            } else {
                if (activePart === 3) window.location.href = window.location.href;
                else next = 0;
            }
        }

        setActivePart(next);
    }

    let part = null;
    switch (activePart) {
        case 0:
            part = <ProductionPerformancePart onDone={showNextPart} />;
            break;
        case 1:
            part = <ProductionNotesPart onDone={showNextPart} />;
            break;
        case 2:
            part = <CalendarEventsPart onDone={showNextPart} />;
            break;
        case 3:
            part = <VideoPart tabs={tabs} showTeamPhotos={showTeamPhotos} onDone={showNextPart} />;
            break;
    }

    return (
        <div className="container mw-100 overflow-hidden">
            {part}
        </div>
    );
}

export interface StatusPageRateProps {
    reports: any;
    users: Array<Account>;
    showPhotos?: boolean;
}
